export default __webpack_public_path__ + "static/media/tele2.9ce37fa1.svg";